import { memo } from 'react';

import { SquareSlashIcon } from '@air/design-icons';

import { MainSideNavItem } from '~/components/v2/components/workspace/main-side-nav/item/MainSideNavItem';
import { useMainSideNavItemSelected } from '~/components/v2/components/workspace/main-side-nav/useMainSideNavItemSelected';
import { Routes } from '~/constants/routes';
import { useTemporaryFeatureFlags } from '~/hooks/useTemporaryFeatureFlags';
import { useCurrentWorkspacePermissionsContext } from '~/providers/CurrentWorkspacePermissionsProvider';
import { canViewSkills } from '~/utils/permissions/workspacePermissions';

export type MainSideNavItemSkillsProps = {
  pathname: string;
};

export const MainSideNavItemSkills = memo(({ pathname }: MainSideNavItemSkillsProps) => {
  const { enableSkillsUi } = useTemporaryFeatureFlags();
  const { data: workspacePermissions } = useCurrentWorkspacePermissionsContext();
  const { isSelected } = useMainSideNavItemSelected({
    isRouteSelected: pathname === Routes.skills,
  });

  if (!enableSkillsUi || !canViewSkills(workspacePermissions)) {
    return null;
  }

  return (
    <MainSideNavItem
      href={Routes.skills}
      icon={SquareSlashIcon}
      id="skills"
      isSelected={isSelected}
      label="Skills"
      sidebarInteractionType="skills"
    />
  );
});

MainSideNavItemSkills.displayName = 'MainSideNavItemSkills';
